import { useTheme } from '@/components/ThemeProvider';
import { formatBalanceWithCommas, formatCryptoPrice, formatTimeAgo, formatValueWithCompactNumber } from '@/lib/format';
import { cn } from '@/lib/utils';
import { IAddressHistory } from '@/request/smartMoney/smartMoney.response.interface';
import { useAppStore } from '@/store';
import { BscIcon, SolIcon } from '@/widget/Icon';
import TokenAvatar from '@/widget/TokenAvatar';
import BigNumber from 'bignumber.js';
import { useNavigate } from 'react-router-dom';

interface IProps {
  activity: IAddressHistory;
}
export default (props: IProps) => {
  const { activity } = props;
  const { lang, fwClass, chainInfo } = useAppStore();
  const navigate = useNavigate();
  const { theme } = useTheme();
  const isTradeBuy = activity.type == 'buy';
  const tradeTypeColor = isTradeBuy ? 'bg-[#3CDEA54D] text-[#3CDEA5]' : 'bg-[#FF6D6D4D] text-[#FF6D6D]';
  const textColor = isTradeBuy ? 'text-buyColor' : 'text-sellColor';
  const totalUsd = BigNumber(activity.price).times(activity.amount).toString();

  const viewHx = (hash: string) => {
    if (chainInfo.chain == 'solana') {
      window.open('https://solscan.io/tx/' + hash);
    } else {
      window.open('https://bscscan.com/tx/' + hash);
    }
  };

  return (
    <div className="flex items-center text-[12px] h-[72px] border-b-[1px] border-borderColor">
      <div className="flex-1">
        <div className="flex gap-x-[4px] mb-[4px]">
          <span className={cn('text-[12px] px-[6px] rounded-[6px]', tradeTypeColor)}>{isTradeBuy ? 'Buy' : 'Sell'}</span>
          <span className={cn(textColor)}>{(isTradeBuy ? '+' : '-') + formatValueWithCompactNumber(activity.amount)}</span>
        </div>
        <p className="text-secondaryTextColor">{formatTimeAgo(activity.activeTime, { style: 'shortAgo', lang })}</p>
      </div>
      <div className="flex-1 flex justify-center items-center gap-x-[6px]">
        <div className="flex items-center gap-x-[6px]" onClick={() => navigate(`/${chainInfo.path}/trade/${activity.tokenAddress}`)}>
          <div className="relative">
            <TokenAvatar logo="" address={activity.tokenAddress} className="w-[30px] h-[30px]" />
            <img src={chainInfo.icon} className="p-[1px] rounded-full bg-[#fff] w-[13px] h-[13px] absolute right-0 bottom-0" />
          </div>
          <span className={cn('text-[14px] text-primaryTextColor', fwClass)}>{activity.symbol}</span>
        </div>
        {chainInfo.chain == 'solana' ? (
          <SolIcon theme={theme} className="size-[18px]" onClick={() => viewHx(activity.signature)} />
        ) : (
          <BscIcon theme={theme} className="size-[18px]" onClick={() => viewHx(activity.signature)} />
        )}
      </div>
      <div className="text-right flex-1">
        <p className="">{formatBalanceWithCommas(totalUsd)}</p>
        <p className="text-secondaryTextColor">${formatCryptoPrice(activity.price)} </p>
      </div>
    </div>
  );
};
